module.exports = "<app-selector\n  class=\"quarter\"\n  [items]=\"quarterItems\"\n  (changeValue)=\"onQuarterChange($event)\">\n</app-selector>\n<app-selector\n  class=\"type\"\n  [items]=\"mapModeItems\"\n  [multilabel]=\"!!false\"\n  [value]=\"selectedMapMode ? selectedMapMode.value : null\"\n  (changeValue)=\"onMapModeChange($event)\">\n</app-selector>"


//////////////////
// WEBPACK FOOTER
// ./src/app/map/map-controls/map-controls.component.html
// module id = ./src/app/map/map-controls/map-controls.component.html
// module chunks = main